/**
 * Base URL for the Catalyst AppSail registration API.
 * Set via REACT_APP_API_BASE_URL (no trailing slash).
 * Deployed: https://registration-api-10129571652.development.catalystappsail.com
 */
export function getApiBaseUrl() {
  const fromEnv = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;

  // Legacy single-endpoint override still supported
  const legacy = (process.env.REACT_APP_REGISTRATION_API_URL || '').replace(
    /\/api\/registration\/submit\/?$/,
    '',
  );
  return legacy.replace(/\/$/, '');
}

export function apiUrl(path) {
  const base = getApiBaseUrl();
  if (!base) return '';
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
